import React from 'react';
import { ServerService } from './../../services/server.service';
import $ from 'jquery';
import { AuditLog } from './../../services/auditlog.service';
import ReactToolTip from 'react-tooltip';
import i18n from '../../i18n';

export default class InstancesSelection extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            firewallName: props.name,
            regionName: props.regionName,
            instanceListApi: [],
            instanceListTemp: [],
            instanceList: [],
            initialInstances: [],
            tmpAddInstances: [],
            inpSearch: '',
            dropDownComp: [],
            selectedInstId: '',
            regionUrl: '',
            selectedIndex: -1,
            instErrorMsg: '',
            selectedInstName: '',
            checked: false
        };
    }

    onInstanceDeleteClick = (index, elem, event) => {

        if(this.state.initialInstances.length > 0) {
            let savedElem = this.state.initialInstances.find(inst => inst.id === elem.id);
            if(savedElem !== undefined) {
                this.openRemovePopup();
                this.setState({ selectedInstId: elem.id, selectedIndex: index, selectedInstName: elem.name });
                return;
            }
        }
        let instList = [...this.state.instanceList];
        let instListTemp = [...this.state.instanceListTemp];
        let tmpList = [...this.state.tmpAddInstances];
        let deletedItem = instList[index];
        instListTemp.push(deletedItem);
        instList.splice(index, 1);
        tmpList.splice(index - this.state.initialInstances.length, 1);

        this.setState({ instanceList: instList, instanceListTemp: instListTemp, tmpAddInstances: tmpList, checked: false });
        event.stopPropagation();
    };

    instanceDelete = () => {
        this.closeRemovePopup();
        this.props.bgShadowHandler(true);
        let requestBody = {
            removeSecurityGroup: {
                name: this.props.name
            }
        };
        let logFirewallName = this.props.name;
        ServerService.serverAction(this.state.selectedInstId, this.state.regionUrl, requestBody).then(resp => {
            this.props.bgShadowHandler(false);
            let i18n = this.props.i18n;
            if(resp || resp === "") {
                let instList = [...this.state.instanceList];
                let instListTemp = [...this.state.instanceListTemp];
                let deletedItem = instList[this.state.selectedIndex];
                instListTemp.push(deletedItem);
                instList.splice(this.state.selectedIndex, 1);
                let iniInstArr = this.state.initialInstances.filter(iniInst => iniInst.id !== this.state.selectedInstId);
                this.setState({ instanceList: instList, instanceListTemp: instListTemp, initialInstances: iniInstArr, checked: false });
                this.props.handler(i18n.t('fw_inst_remove_success'), 'success');
                document.getElementById('inpSearch').focus();
                $('.added_applyInstance').addClass('active');
                const editFirewall = {
                    "userId": localStorage.getItem("userId"),
                    "name": "Instance " + this.state.selectedInstName + " has been removed from firewall " + logFirewallName,
                    "operation": "Instance removed from firewall"
                };
                AuditLog.storeAuditLogs(editFirewall, "instance").then((resp) => {
                    if(resp === false);
                });
                return;
            }
            this.props.handler(i18n.t('fw_inst_remove_failure'), 'error');
        });
    };

    onChangeHandler = (event) => {
        $('.added_applyInstance').addClass('active');
        let name = event.target.name;
        let val = event.target.value;
        let filtDropDownComp = this.state.instanceListTemp.filter(inst => inst.name.toLowerCase().includes(val.toLowerCase()));
        this.setState({ [name]: val, dropDownComp: filtDropDownComp, instErrorMsg: '' });
        $('.addedInstance_dropdown').addClass('active');
        event.stopPropagation();
    };

    selectedInstance = (object, event) => {
        let instList = this.state.instanceList;
        instList.push(object);
        let tmpList = this.state.tmpAddInstances;
        tmpList.push(object);
        let dropDownFilt = this.state.instanceListTemp.filter(elem => elem.id !== object.id);
        let checkedVal = false;
        if(dropDownFilt.length === 0)
            checkedVal = true;
        this.setState({ instanceList: instList, dropDownComp: dropDownFilt, instanceListTemp: dropDownFilt, inpSearch: '', instErrorMsg: '', tmpAddInstances: tmpList, checked: checkedVal });
        $('.addedInstance_dropdown').removeClass('active');
        //document.getElementById('inpSearch').focus();;
        event.stopPropagation();
    };

    handleMultiselect = (event) => {
        console.log(event.target.checked);
        let bool = event.target.checked;
        if(bool) {
            let instList = [...this.state.instanceList];
            let tmpList = [...this.state.tmpAddInstances];
            this.state.instanceListTemp.map((obj, i) => {
                instList.push(obj);
                tmpList.push(obj);
                return obj;
            });
            this.setState({ checked: bool, instanceList: instList, dropDownComp: [], instanceListTemp: [], tmpAddInstances: tmpList, inpSearch: '', instErrorMsg: '' });
        }
        else {
            let instList = [...this.state.initialInstances];
            let tmpList = [...this.state.instanceListTemp];
            this.state.tmpAddInstances.forEach((obj) => {
                tmpList.push(obj);
            });
            if(tmpList.length === 0) {
                bool = true;
            }
            this.setState({ checked: bool, instanceList: instList, dropDownComp: tmpList, instanceListTemp: tmpList, tmpAddInstances: [], inpSearch: '', instErrorMsg: '' });
        }
        $('.added_applyInstance').addClass('active');
        event.stopPropagation();
    };

    componentDidMount() {
        this.props.bgShadowHandler(true);
        ServerService.getRegionListByType('compute').then(regionList => {
            if(regionList) {
                let region = regionList.find(regionItem => regionItem.region === this.props.regionName);
                this.setState({ regionUrl: region.url });
                this.getAttachedInstances(region.url);
            }
            if(!Array.isArray(regionList)) {
                this.props.bgShadowHandler(false);
            }
        });
    }

    checkBmInstance = (flavorId) => {
        try {
            let flavorList = JSON.parse(localStorage.getItem('BMflavors'));

            if(flavorList !== null && flavorList !== undefined) {
                let flavorObj = undefined;
                try {
                    flavorObj = flavorList.find(item => item.id === flavorId);
                }
                catch(err) {
                    return true;
                }

                if(flavorObj === undefined) {
                    return true;
                }


                if(flavorObj.type === "BM") {
                    return false;

                }
                //localStorage.setItem(flavorId, type + ', ' + processor + 'vCPU, ' + ram + ' RAM, ' + storage + ' NVMe storage')
                return true;
            }
        } catch(e) {

        }
        return true;
    };


    getAttachedInstances(regionUrl) {
        let attachedInstances = [];
        let nonAttachInstances = [];
        let checkedVal = false;
        ServerService.getServerListByRegion(regionUrl).then(resp => {
            this.props.bgShadowHandler(false);
            if(resp.length > 0) {
                resp.forEach(instance => {
                    if(this.checkBmInstance(instance.flavorId)) {
                        if(instance.security_groups !== undefined) {
                            let firewallObj = instance.security_groups.find(item => item.name === this.props.name);
                            if(firewallObj !== undefined) {
                                attachedInstances.push(instance);
                            } else {
                                nonAttachInstances.push(instance);
                            }
                        }
                        else if(instance.status !== 'ERROR') {
                            nonAttachInstances.push(instance);
                        }
                    }
                });
                if(nonAttachInstances.length === 0)
                    checkedVal = true;
                this.setState({ initialInstances: [...attachedInstances], instanceList: [...attachedInstances], instanceListApi: [...nonAttachInstances], instanceListTemp: [...nonAttachInstances], checked: checkedVal });
            }
        });
    }
    onApplyClick() {
        this.setState({ inpSearch: '', tmpAddInstances: [] });
        if(this.state.instanceList.length === 0) {
            document.getElementById('inpSearch').focus();
            this.setState({ instErrorMsg: 'Please select an instance' });
            $('.added_applyInstance').addClass('active');
            return;
        }
        let isChange = false;
        this.state.instanceList.forEach(item => {
            let findElem = this.state.initialInstances.find(elem => elem.id === item.id);
            if(findElem === undefined) {
                isChange = true;
                this.addFirewallToInst(item);
            }
        });
        if(!isChange) {
            document.getElementById('inpSearch').focus();
            this.setState({ instErrorMsg: 'There are no changes to apply' });
            $('.added_applyInstance').addClass('active');
        }

    }

    addFirewallToInst(item) {
        let requestBody = {
            addSecurityGroup: {
                name: this.props.name
            }
        };
        let logFirewallName = this.props.name;
        let logInstanceName = item.name;
        this.props.bgShadowHandler(true);
        ServerService.serverAction(item.id, this.state.regionUrl, requestBody).then(resp => {
            this.props.bgShadowHandler(false);
            if(resp || resp === "") {
                // if(resp.itemNotFound!==undefined && resp.itemNotFound.message){
                //     this.props.handler(resp.itemNotFound.message,'error')
                //     return
                // }
                this.props.handler(i18n.t('fw_inst_apply_success'));
                const editFirewall = {
                    "userId": localStorage.getItem("userId"),
                    "name": "Instance " + logInstanceName + " has been applied to firewall " + logFirewallName,
                    "operation": "Instance added to firewall"
                };
                AuditLog.storeAuditLogs(editFirewall, "instance").then((resp) => {
                    if(resp === false);
                });
                let initInst = this.state.initialInstances;
                initInst.push(item);
                this.setState({ initialInstances: initInst });
            }
            else {
                this.props.handler(i18n.t('fw_inst_apply_failure'), "error");
                let instListTemp = [...this.state.instanceListTemp];
                instListTemp.push(item);
                let instList = this.state.instanceList.filter(elem => elem.id !== item.id);
                this.setState({ instanceListTemp: instListTemp, dropDownComp: instListTemp, instanceList: instList, checked: false });
            }
        });
    }

    onFocusOut(e) {
        //  if (e.currentTarget === e.target) {
        //     console.log('focused self');
        //   } else {
        //     console.log('focused child');
        //   }
        if(!e.currentTarget.contains(e.relatedTarget)) {
            if($("#inpSearch").is(":focus")) {
                setTimeout(() => {
                    $('.addedInstance_dropdown').removeClass('active');
                }, 200);
            }
        }
    }

    onInstClick(event) {
        document.getElementById('inpSearch').focus();
        // let val = document.getElementById('inpSearch').value.trim().toLowerCase();
        // let filtDropDownComp = this.state.instanceListTemp.filter(inst=>inst.name.toLowerCase().includes(val));
        // this.setState({dropDownComp:filtDropDownComp,instErrorMsg:''});
        // $('.added_applyInstance').addClass('active');
        // event.stopPropagation();
    }

    closeRemovePopup() {
        $('#instDelPopup').removeClass('active');
        $("body").removeClass("popup_no_scroll");
    }

    openRemovePopup() {
        $('#instDelPopup').addClass('active');
        $("body").addClass("popup_no_scroll");
        setTimeout(() => document.getElementById('removeBtn').focus(), 200);

    }

    render() {
        return (
            <React.Fragment>

                <div className="apply_instance_wrap multiselect">
                    <h2>Apply to Instances</h2>
                    <p className="title_info">Push the configured firewall rules to instances</p>
                    <p className="title_info"><strong>Note:</strong> Firewalls cannot be applied to Bare metal instances.</p>
                    <div className="add_instances">
                        <label className="checkBox applyToall">
                            <input type="checkbox" name="applytoall" value="false" checked={ this.state.checked } onChange={ this.handleMultiselect } />
                            <span className="checkmark"></span>
                            <p className="add_on_head"><span>Apply this firewall to all instances</span>
                            </p>
                        </label>
                        <span className="question_icon" data-toggle="tooltip" data-placement="top" title="" data-tip data-for="autoselect" >
                            <svg x="0px" y="0px" viewBox="0 0 22 20" style={ { enableBackground: 'new 0 0 22 20' } } xmlSpace="preserve">
                                <path fill-rule="evenodd" clip-rule="evenodd" fill="#89A2BE" d="M11,1c5,0,9,4,9,9s-4,9-9,9c-5,0-9-4-9-9S6,1,11,1z"></path>
                                <text transform="matrix(1 0 0 1 7.0724 15.4681)" fill="#FFFFFF" font-family="'Roboto-Medium'" font-size="15px">?</text>
                            </svg><ReactToolTip id="autoselect" place="top" effect="solid">Enabling this will apply the firewall settings to <br /> all the instances present in this region.</ReactToolTip>
                        </span>
                    </div>
                    <div className="added_applyInstance" onClick={ (e) => this.onInstClick(e) } onBlur={ (e) => this.onFocusOut(e) } onFocus={ (e) => this.onChangeHandler(e) }>
                        <ul className="tags_container" >
                            { this.state.instanceList.map((elem, i) =>
                                <li key={ i }>
                                    <div className="source_tag" > <span className="instance_icon"><span className="svg_wrap">
                                        <svg x="0px" y="0px" width="100px" height="100px" viewBox="0 0 100 100" style={ { enableBackground: 'new 0 0 100 100' } } xmlSpace="preserve">
                                            <path fill="#FFFFFF" d="M73.6,26.7c0,0,4.8,3.5,1.8,9.4l-2.8,5.3l-16.4-9.3c0,0-2.8-1.4-5.4,0.1l-13,7c0,0-2.3,0.8-2.3,2.9v14.5
		                                                                                    c0,0-0.6,2.4,1.6,3.5l14,8.3c0,0,2.6,1.6,5.5-0.2l15.2-9.8l2.8,3.7c0,0,4.5,6-1.1,10.8l-16,9.9c0,0-3,2.2-7.2-0.2L26.6,69.1
		                                                                                    c0,0-3.5-1.3-3-5.8V36.1c0,0-0.5-3,2-5l23.8-13.5c0,0,4.1-2.4,7-0.7L73.6,26.7z"></path>
                                        </svg>
                                    </span> </span>
                                        <div className="row_wrap"> <span className="row row_head">{ elem.name }</span>
                                            <span className="row row_info">{ elem.status === 'SHELVED_OFFLOADED' ? "SUSPENDED" : elem.status }</span>
                                        </div>
                                        <span className="close_icon" onClick={ (e) => this.onInstanceDeleteClick(i, elem, e) }></span> </div>
                                </li>
                            ) }

                            <span className="inp_box" >
                                <input id="inpSearch" type="text" name="inpSearch" className="input_search" value={ this.state.inpSearch } style={ { width: '100%' } }
                                    onChange={ (e) => this.onChangeHandler(e) } onClick={ (e) => this.onChangeHandler(e) } autoComplete="off"></input>
                            </span>
                        </ul>
                        <div className="dropdown_component addedInstance_dropdown" >
                            <ul >{ this.state.dropDownComp.map((ob, k) =>
                                <li key={ k } onClick={ (e) => this.selectedInstance(ob, e) }><span className="instance_name">{ ob.name }</span></li>
                            ) }
                            </ul>
                            <li style={ { display: this.state.dropDownComp.length === 0 ? '' : 'none' } }>No instance available to apply</li>
                        </div>
                    </div>
                    <div className="add_instance_cta" onClick={ () => this.onApplyClick() }>Apply</div>
                    <span className="comm_error_msg" style={ { width: '100%', float: 'left' } }>{ this.state.instErrorMsg }</span>
                </div>
                <div className="main_popup delete_firewall_popup" id="instDelPopup">
                    <div className="main_popup_wrapper">
                        <div className="main_popup_bg_shadow"></div>
                        <div className="main_popup__inner">
                            <div className="popup_wrap"> <span className="close_icon" data-toggle="tooltip" title="" data-original-title="Close" onClick={ () => this.closeRemovePopup() }></span>
                                <div className="popup_header">
                                    <div className="sub_title">Remove</div>
                                </div>
                                <div className="popup_body">
                                    <p className="popup_remove_content">Remove the configured firewall rules from the instance <b>{ this.state.selectedInstName }</b> ?</p>
                                </div>
                                <div className="popup_footer">
                                    <div className="popup_footer__btns">
                                        <button id="removeBtn" className="btn btn_confirm" onClick={ () => this.instanceDelete() }>Remove</button>
                                        <button className="btn btn_cancel" onClick={ () => this.closeRemovePopup() }>Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }

}